export async function sha256Hex(input) {
  if (!input) return undefined;

  const normalized = String(input).trim().toLowerCase();
  if (!normalized) return undefined;

  if (typeof window !== "undefined" && window.crypto && window.crypto.subtle) {
    const encoder = new TextEncoder();
    const data = encoder.encode(normalized);
    const hashBuffer = await window.crypto.subtle.digest("SHA-256", data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
  }

  const crypto = require("crypto");
  return crypto.createHash("sha256").update(normalized, "utf8").digest("hex");
}

export function normalizePhoneForHash(phone) {
  if (!phone) return undefined;
  const digits = String(phone).replace(/\D/g, "");
  return digits || undefined;
}
